/* eslint-disable react/no-array-index-key */
import React, { useState, useContext, useMemo } from 'react';
import { Tooltip, Card } from 'antd';
import clsx from 'clsx';
import Icon from 'component/icon';
import { TableContext } from './context';

const ActionIcon = (props) => {
    const { element, title, onClick, onMouseEnter, className } = props;

    const content = (
        <div
            className={clsx(
                'flex justify-center items-center w-[30px] h-[30px] rounded-full cursor-pointer',
                'shadow-[0_0_6px_rgba(0,0,0,0.3)]',
                className
            )}
            onClick={onClick}
            onMouseEnter={onMouseEnter}
        >
            {element}
        </div>
    );

    return (
        <Tooltip
            destroyTooltipOnHide={{ keepParent: false }}
            placement="bottom"
            overlayClassName="table-tooltip"
            title={!!title && (
                <Card
                    className="text-sm text-white bg-gray-dark02"
                    bodyStyle={{ padding: '4px 8px' }}
                >
                    {title}
                </Card>
            )}
        >
            {content}
        </Tooltip>
    );
};

const RowAction = (props) => {
    const { row, rowAction, className, style } = props;
    const {
        rowKey,
        hover,
        hoverRow,
        setHoverRow,
        selectable,
        selectedRow,
        setSelectedRow,
        onSelectRowRef,
        actionGradient
    } = useContext(TableContext);

    const filterRowAction = useMemo(() => rowAction?.filter((item) => (
        item?.isShow !== false && item.element && !item?.hideList?.includes(hoverRow)
    )), [hoverRow, rowAction]);

    const [rowActionExpanded, setRowActionExpanded] = useState(false);
    const rowActionExpandable = useMemo(() => (
        filterRowAction?.some((item) => item.isExpand)
    ), [filterRowAction]);

    return !!filterRowAction?.length && (
        <div
            className={clsx('flex', className)}
            style={style}
            onMouseEnter={() => setHoverRow(row[rowKey])}
            onClick={() => {
                setSelectedRow(row[rowKey]);
                onSelectRowRef.current?.(row[rowKey]);
            }}
        >
            {actionGradient && (
                <div
                    className={clsx(
                        'h-full w-[50px] pointer-events-none',
                        'bg-gradient-to-r from-transparent via-table-row to-table-row',
                        {
                            'via-table-row-hover to-table-row-hover':
                                hover && (hoverRow !== selectedRow || !selectable)
                        },
                        {
                            'via-table-row-selected to-table-row-selected':
                                selectable && hoverRow === selectedRow
                        }
                    )}
                />
            )}
            <div
                className={clsx(
                    'h-full flex items-center gap-1 px-2 pointer-events-auto'
                    // { 'bg-table-row-hover': hover && (hoverRow !== selectedRow || !selectable) },
                    // { 'bg-table-row-selected': selectable && hoverRow === selectedRow }
                )}
                onMouseLeave={() => setRowActionExpanded(false)}
            >
                {rowActionExpandable && (
                    <ActionIcon
                        element={<Icon name="chevron_left" />}
                        onMouseEnter={() => setRowActionExpanded(true)}
                        className={rowActionExpanded ?
                            'bg-[#45598D] text-white' : 'bg-white text-[#45598D]'}
                    />
                )}
                {rowActionExpanded && filterRowAction.map((item, index) => item.isExpand && (
                    <ActionIcon
                        key={index}
                        title={item?.title}
                        element={item.element}
                        onClick={() => item.onClick?.(row)}
                        className="bg-white hover:bg-rowaction"
                    />
                ))}
                {filterRowAction.map((item, index) => !item.isExpand && (
                    <ActionIcon
                        key={index}
                        title={item?.title}
                        element={item.element}
                        onClick={() => item.onClick?.(row)}
                        className="bg-white hover:bg-rowaction"
                    />
                ))}
            </div>
        </div>
    );
};

export default RowAction;
